export enum DefaultEmailTemplateType {
    StaffUserInvite = "Staff User Invite",
    FamilyUserInvite = "Family User Invite",
    BroadcastEmail = "Broadcast Email",
    FamilyNotifications = "Family notifications",
    ServiceApproval = "Service Approval",
    FamilyUserChangeEmail = "Family User Change Email",
    FamilyReminderEmail = "Family Reminder Email",
    ServiceRequestToVendor = "Service Request to Vendor",
    ResidentInvite = "Resident invite",
    ResidentVerificationEmail = "Resident verification email",
    FamilyMemberVerificationEmail = "Family member verification email",
    FamilyAppProfileDeletion = "Family App profile deletion",
    SurveyEmail = "Survey Email",
    MaintenanceVendors = "Maintenance Vendors",
    MaintenanceUserInvite = "Maintenance User Invite"
}